import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * Drag-to-resize width for a panel anchored to the right edge of the viewport (e.g. a detail
 * sidebar) — dragging the handle left widens the panel, dragging right narrows it.
 */
export function useResizableWidth({ defaultWidth, minWidth = 320, maxWidth = 960 }) {
    const [width, setWidth] = useState(defaultWidth);
    const dragStart = useRef(null);
    const handleMouseMove = useCallback((e) => {
        if (!dragStart.current)
            return;
        const delta = dragStart.current.x - e.clientX;
        setWidth(Math.min(maxWidth, Math.max(minWidth, dragStart.current.width + delta)));
    }, [minWidth, maxWidth]);
    const stopResizing = useCallback(() => {
        dragStart.current = null;
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
    }, []);
    useEffect(() => {
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', stopResizing);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', stopResizing);
        };
    }, [handleMouseMove, stopResizing]);
    const startResizing = useCallback((e) => {
        e.preventDefault();
        dragStart.current = { x: e.clientX, width };
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
    }, [width]);
    return { width, startResizing };
}
